

















































import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import CounterDataDeleteDialog from '@/components/counters/CounterDataDeleteDialog.vue';
import { CounterDataModule } from '@/store/dashboard/counters-data/CounterDataModule';
import { resolveModule } from '@/store';
import { CounterData } from '@/modules/backend/Entities/CounterData';

function digitWithLeadingZero(val: number): string {
  const DIGITS_NUMBER = 2;

  const sign = Math.sign(val) === -1 ? '-' : '';
  return sign + new Array(DIGITS_NUMBER).concat([Math.abs(val)]).join('0').slice(-DIGITS_NUMBER);
}

function formatDate(date: Date): string {
  return `${
    digitWithLeadingZero(date.getDate())
  }.${
    digitWithLeadingZero(date.getMonth() + 1)
  }.${
    date.getFullYear()
  } ${
    digitWithLeadingZero(date.getHours())
  }:${
    digitWithLeadingZero(date.getMinutes())
  }`;
}

@Component({
  mixins: [Mixin],
  components: {
    'data-table-wrapper': DataTableWrapper,
    'counter-data-delete-dialog': CounterDataDeleteDialog,
  },
  filters: {
    dateFormat(date: Date): string {
      return formatDate(new Date(date));
    },
    cubicMetersToLiters(val: number | string): number {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      return Number(val) / 1000;
    }
  }
})
export default class CounterDataTable extends Mixins(Mixin) {
  @Prop({ required: true }) private counterId!: number;

  private readonly countersDataModule: CounterDataModule = resolveModule(CounterDataModule);
  private sortBy = 'timestamp';
  private sortDesc = true;
  private selected: CounterData[] = [];

  public async mounted(): Promise<void> {
    await this.countersDataModule.fetch({
      counterId: this.counterId
    });
  }

  private get counterData(): CounterData[] {
    return (this.countersDataModule.get)(this.counterId);
  }

  private get itemsPerPage(): number {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return 10;
  }

  private get showFooter(): boolean {
    return this.counterData.length > this.itemsPerPage;
  }

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id',
      },
      {
        text: this.$i18n.t('screens.account.counters.data.headers.value').toString(),
        sortable: true,
        value: 'value'
      },
      {
        text: this.$i18n.t('screens.account.counters.data.headers.timestamp').toString(),
        sortable: true,
        sort: (a: Date, b: Date): number => {
          if (a < b) return -1;
          if (a === b) return 0;
          return 1;
        },
        value: 'timestamp'
      },
      {
        text: '',
        align: 'end',
        value: 'actions'
      }
    ];
  }

  private async removeSelected(): Promise<void> {
    for (const data of this.selected) {
      const found = this.counterData.find(i => i.getId() === data.getId());
      if (!found) {
        return;
      }
      await this.countersDataModule.remove(data);
      this.selected = this.selected.filter(i => i.getId() !== data.getId());
    }
  }
}
